import { apiUrl } from '@/config/api';

export async function fetchCheckoutReadiness() {
  try {
    const response = await fetch(apiUrl('/api/payments/checkout-readiness'), {
      credentials: 'omit',
    });
    if (!response.ok) {
      return {
        usdCheckoutAvailable: false,
        reason: 'unavailable',
        message: 'Card checkout is not available yet. Email care@getbyonco.com.',
      };
    }
    const data = await response.json();
    return {
      usdCheckoutAvailable: data.usdCheckoutAvailable === true,
      reason: data.reason || 'unknown',
      message: data.message || 'Card checkout is not available yet.',
    };
  } catch {
    return {
      usdCheckoutAvailable: false,
      reason: 'unavailable',
      message: 'Card checkout is not available yet. Email care@getbyonco.com.',
    };
  }
}
